<div class="row w-100 pt-3 text-center row-title">
    @if (!active) {
        <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Activation de l'option Conférence à 3</div>
    }
    @if (active) {
        <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Désactivation de l'option Conférence à 3</div>
    }
</div>
<div class="row w-100 pt-3 text-center">
    <div class="col-12 w-100">
        Je souhaite
        @if (!active) {
            <span>activer</span>
        }
        @if (active) {
            <span>désactiver</span>
        } l'option Conférence à 3 sur ma ligne <strong>{{ line.phoneNumber }}</strong>.
        @if (!active) {
            <span>Cette option vous sera facturée {{ priceDetails?.price }}
            @if (priceDetails?.perMonth) {
                <span>/mois</span>
            } en plus de votre forfait habituel.</span>
        }
        <br/><br/>
    </div>
    <div class="col-12 w-100 cta_container">
        <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
        <button type="button" class="cta_btn level_2 column" (click)="confirmation()">Valider<span></span></button>
    </div>
</div>
